import language from "./languageReducer";

export default {
    language
};